import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

import enUS from './locales/en-US.json';
import ptBR from './locales/pt-BR.json';

export const IDIOMAS_SUPORTADOS = [
  { code: 'pt-BR', label: 'Portugues (BR)', flag: '🇧🇷' },
  { code: 'en-US', label: 'English (US)', flag: '🇺🇸' },
] as const;

const STORAGE_KEY = 'octawash:idioma';

void i18n.use(initReactI18next).init({
  resources: {
    'pt-BR': { translation: ptBR },
    'en-US': { translation: enUS },
  },
  lng: localStorage.getItem(STORAGE_KEY) ?? 'pt-BR',
  fallbackLng: 'pt-BR',
  interpolation: { escapeValue: false },
});

export function trocarIdioma(code: string) {
  void i18n.changeLanguage(code);
  localStorage.setItem(STORAGE_KEY, code);
  if (typeof document !== 'undefined') {
    document.documentElement.setAttribute('lang', code);
  }
}

if (typeof document !== 'undefined') {
  document.documentElement.setAttribute('lang', i18n.language);
}

export default i18n;
